import type { ErrorLoggerConfig } from "../types";

const defaultConfig: ErrorLoggerConfig = {
  enabled: !import.meta.env.DEV,
  service: undefined,
};

let config: ErrorLoggerConfig = defaultConfig;

export function configureErrorLogger(userConfig: Partial<ErrorLoggerConfig>) {
  config = { ...defaultConfig, ...userConfig };
}

export function logError(error: unknown, context?: Record<string, unknown>) {
  if (!config.enabled) {
    return;
  }

  const errorData = {
    error: serializeError(error),
    context: {
      ...context,
      route: window.location.pathname,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    },
  };

  console.error("[ErrorBoundary]", errorData);

  switch (config.service) {
    case "sentry":
      logToSomeWhatcher(errorData);
      break;
    default:
      break;
  }
}

function serializeError(error: unknown) {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }
  return { raw: String(error) };
}

function logToSomeWhatcher(errorData: unknown) {
  console.log("[SomeWhatcher]", errorData);
}
